/**
 * Format a decimal rate (0–1) as a whole-number percentage string, e.g. 0.75 → "75%".
 * Returns empty string for undefined or null.
 */
export const formatPercent = (value?: number | null): string => {
  if (value === undefined || value === null) return '';
  return `${Math.round(value * 100)}%`;
};

// Format large numbers to be more readable in the chart
export const formatLargeNumber = (
  num?: number,
  prefix: string = '$',
  truncate: boolean = true,
): string => {
  if (!truncate) {
    return prefix + num?.toString();
  }
  if (num && num >= 1e9) {
    return prefix + (num / 1e9).toFixed(1) + 'B';
  }
  if (num && num >= 1e6) {
    return prefix + (num / 1e6).toFixed(1) + 'M';
  }
  if (num && num >= 1e3) {
    return prefix + (num / 1e3).toFixed(1) + 'K';
  }
  return prefix + num?.toString();
};
